import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Button } from 'apps/shared/scripts/components';
import { ModalTypes, openModal } from 'apps/shared/scripts/redux';

import messages from './messages.json';
import {
  buttonClassName,
  buttonIconClassName,
  buttonTextClassName,
} from './styles';

const CardHeroCta = () => {
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    dispatch(openModal({ type: ModalTypes.AddCardPost }));
  }, [dispatch]);

  return (
    <Button
      className={buttonClassName}
      faIcon={faPlus}
      iconClassName={buttonIconClassName}
      onClick={onClick}
      textClassName={buttonTextClassName}
    >
      {messages.ctaLabel}
    </Button>
  );
};

CardHeroCta.displayName = 'CardHeroCta';

export default CardHeroCta;
